module.exports = __webpack_public_path__ + "img/floor_UG1.fd0ad051.svg";